import { Component } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { Input } from '@angular/core';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css'],
})
export class BarChartComponent {
  @Input() chartData: ChartConfiguration<'bar'>['data'] | undefined;
  @Input() yAxisTitle: any;
  @Input() xAxisTitle: any;

  get barChartOptions(): ChartConfiguration<'bar'>['options'] {
    return {
      responsive: true,

      scales: {
        x: {
          display: true,
          weight: 10,

          ticks: {
            color: '#0058e9',
          },
          grid: {
            display: false,
          },
          title: {
            display: true,

            text: this.xAxisTitle,

            font: {
              size: 12,
            },
            color: '#0058e9',
          },
        },
        y: {
          display: true,
          weight: 10,

          ticks: {
            display: false,
          },
          grid: {
            display: false,
          },
          title: {
            display: true,
            text: this.yAxisTitle,
            font: {
              size: 12,
            },
            color: '#0058e9',
          },
        },
      },
      plugins: {
        legend: {
          display: true,
        },
      },
    };
  }
}
